<template>
  <div class="home">
    <home-sidebar-nav />
    <router-view></router-view>
  </div>
</template>

<script>
import HomeSidebarNav from './HomeSidebarNav';

export default {
  components: {
    HomeSidebarNav
  }
};
</script>

<style src="./styles/index.css" />
